import React, { FC } from "react";
import { graphql } from "gatsby";
import Layout from "../components/App/Layout";
import ArticleDetailsContent from '../components/Article/ArticleDetailsContent';
import Bookdemo from "../components/Start/Bookdemo";
import SEO from "../components/App/SEO";
import { AuthorImage, HeadProps } from "../utils/core";
import { ArticleQueryData, SeriesArticle } from "../utils/core";

export const Head: FC<HeadProps> = ({ data }) => {
  const article = data.markdownRemark;
  return <SEO title={article?.frontmatter?.title} description={article?.frontmatter?.description}  />;
};

interface NewsQueryData extends ArticleQueryData { };

const BlogTemplate: FC<{ data: NewsQueryData }> = ({ data }) => {
  const { markdownRemark, authordetails, authorimages, seriesarticles } = data;
  const article = markdownRemark;

  const authorNode = authordetails.edges.find(
    (a) => a.node.email === article?.frontmatter?.authorid
  );
  const authorImage = authorimages.edges.find(
    (a) => (a.node.name + a.node.ext) === authorNode?.node?.imagename
  );

  // Extracting the nodes from seriesarticles edges
  const relatedArticles: SeriesArticle[] = seriesarticles.edges
    .filter((a) => a?.node?.frontmatter?.serieslabel === article?.frontmatter?.serieslabel)
    .sort((a, b) => {
      const dateA: Date = new Date(a?.node?.frontmatter?.date);
      const dateB: Date = new Date(b?.node?.frontmatter?.date);
      return dateA.getTime() - dateB.getTime();
    })
    .map(edge => edge.node);
  []
  if (article) {
    if (authorNode) {
      article.author = authorNode?.node;
      article.author.authorImage = authorImage?.node  as AuthorImage;
    }
    article.frontmatter.seriesarticles = relatedArticles;
  }
  
  return (
    <Layout>
      <ArticleDetailsContent article={article} />
      <Bookdemo />
    </Layout>
  );
};

export default BlogTemplate;

export const query = graphql`
query StoriesQuery($id: String, $language: String, $serieslabel: String, $category: [String]) {
  markdownRemark(id: { eq: $id }) {
    frontmatter {
      authorid
      category
      date
      blogimage {
          childImageSharp {
            gatsbyImageData
          }
        }
      slug
      title
      description
      serieslabel
      videoId
      videoTitle
    }
      html
      id
      }
      authordetails: allAuthor(filter: {locale: {eq: $language}}){
        edges {
          node {
            authorname
            description
            email
            id
            imagename
          }
        }
      }
      authorimages: allFile(filter: {sourceInstanceName: {eq: "authorsimages"}}) {
        edges {
          node {
            name
            ext
            sourceInstanceName
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
      locales:  allLocale(filter: {language: {eq: $language}, ns: {in: ["components","pages"]}}) {
        edges {
          node {
            ns
            language
            data
          }
        }
      }
      seriesarticles: allMarkdownRemark( filter: {frontmatter: {serieslabel: {eq: $serieslabel, ne: null}, category:{ in: $category}}}) {
        edges {
          node {
            frontmatter {
              date
              slug
              title
              serieslabel
            }
            id
          }
        }
      }
    }
`;